
import { Patient, Entity, PatientInfo, PatientOptions, MeasureData, PatientFormData } from '@/types';
import { getDefaultPagination, getPagination, DOWNLOADKEYS } from '@/utils/store-util';
import { formatUserInfo } from '@/utils/app-util';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { getPatientsList, setPatientsInfo, createPatient, getPatientRecordByUuid,getMeasurementTypes } from '@/api/patientsService';
import store from '@/store';
import lodash from "lodash";

export interface PatientState {
  pagination: Pagination;
  loading: boolean;
  download_loading: boolean;
  patients: Patient[];
  items: PatientInfo[];
}

@Module({ store, dynamic: true, name: 'patientModule' })
class PatientModule extends VuexModule implements PatientState {
  public pagination = getDefaultPagination();
  public loading = false;
  public download_loading = false;
  measureDataInit: MeasureData = {
    measure_at: '',
    category: '',
    type: '',
    unit: '',
    uuid: '',
    value: 0
  };
  public patientRecords = undefined;
  public downloaduuid = []
  public downloadjson = []
  public patients: Patient[] = [];
  public totalPatients = 0;
  public totalPages = 0;
  public currentPage = 1;
  public items: PatientInfo[] = [];
  public measurementTypes = {};
  public exportkeys = Object.keys(DOWNLOADKEYS);

  @Action({ rawError: true }) async getDownloadData(options: PatientOptions): Promise<TODO> {
    this.setLoading(true);
    this.clearDownloaduuid();
    this.clearDownloadjson();
    const temp  = [];
    for (let p = 1; p<=this.totalPages;p++){
      // console.log(options.q);
      const data = lodash.cloneDeep(await getPatientsList({
        q:options.q,
        page:p,
        place:options.place
      }));
      for (const element of data.users){
        // console.log(element.user.name);
        temp.push({...element.user});
      }
    }
    this.setDownloaduuid(temp);
    const temp2 = [];
    for (const user of this.downloaduuid){
      const data = await getPatientRecordByUuid({uuid: user.uuid,limit: -1,range: options.range});
      const userrecord = data.records;
      await userrecord.sort((a, b) => {
        return new Date(a.measure_at).getTime() < new Date(b.measure_at).getTime()
          ? 1
          : new Date(b.measure_at).getTime() < new Date(a.measure_at).getTime()
            ? -1
            : 0;
      });
      const userrecord_temp = {};

      if(userrecord.length !== 0){
        await userrecord.forEach((element) => {
        if (this.exportkeys.includes(this.measurementTypes[element.key].i18n.zh)) {
          element.measure_at = new Date(
            element.measure_at * 1000
          ).toLocaleString('zh-TW',{
            day: '2-digit',    //(e.g., 01)
            month: '2-digit',    //(e.g., 06)
            year: 'numeric',   //(e.g., 2021)
            hour: '2-digit',   //(e.g., 02)
            minute: '2-digit', //(e.g., 02)
            second: '2-digit', //(e.g., 05)
          });
          if (element.key === 'body_temperature') element.value = parseFloat(element.value).toFixed(1);
          if (element.key === 'blood_glucose') element.value = Math.floor(parseFloat(element.value));
          if (element.measure_at === userrecord_temp['日期'] && element.device===userrecord_temp['機器']){
            userrecord_temp[this.measurementTypes[element.key].i18n.zh] = element.value;
          }else{
            if(!lodash.isEmpty(userrecord_temp)) temp2.push(lodash.cloneDeep(userrecord_temp));
            Object.keys(userrecord_temp).forEach(k => delete userrecord_temp[k]);
            userrecord_temp['日期'] = element.measure_at;
            userrecord_temp['iid'] = user.iid
            userrecord_temp['姓名'] = user.name;
            userrecord_temp['機器'] = element.device;
            Object.entries(this.measurementTypes).forEach(([key, value]) => {
              if (key === element.key){
                userrecord_temp[value['i18n'].zh] = element.value;
              }else{
                userrecord_temp[value['i18n'].zh] = null;
              }
            });
          }
        }
      });
      if(!lodash.isEmpty(userrecord_temp)) temp2.push(lodash.cloneDeep(userrecord_temp));
    }
  
    }
    this.setDownloadjson(temp2);
    this.setLoading(false);
  }


  @Action({ rawError: true }) async getPatientsByPages(options: PatientOptions): Promise<TODO> {
    this.setLoading(true);
    await this.clearPatients();
    this.setMeasurementTypes(await getMeasurementTypes());
    const data = lodash.cloneDeep(await getPatientsList(options));
    this.setTotalPatients(data.total_users);
    this.setTotalPages(data.total_page);
    this.setCurrentPage(options.page);
    // Extract Table Data
    this.setPatients(await formatUserInfo(data.users));
    this.extractPatientInfo(this.patients);
    this.setDataTable(this.items);
    this.setLoading(false);
  }

  @Action async setPatientsInfo(param): Promise<TODO> {
    this.setLoading(true);
    await setPatientsInfo(param.uuid, param.params);
    this.setLoading(false);
  }


  @Action async createPatient(info: PatientFormData): Promise<TODO> {
    this.setLoading(true);
    createPatient(info)
    this.setLoading(false);
  }

  @Action({ rawError: true })
  async extractPatientInfo(patients: Patient[]) {
    patients.forEach(element => {
      if (element.user) {
        this.items.push(element.user);
      }
    });
  }

  @Action({ rawError: true }) setDataTable(data: Entity[]) {
    const pagination = getPagination(data, this.totalPages, this.currentPage);
    this.setPagination(pagination);
  }

  @Action clearDownloaduuid(){
    this.setDownloaduuid([]);
  }
  @Action clearDownloadjson(){
    this.setDownloadjson([]);
  }
  @Action async clearPatients() {
    this.setPatients([]);
    this.setItems([]);
    this.setTotalPages(0);
    this.setTotalPatients(0);
    this.setPagination(getDefaultPagination());
    this.setMeasurementTypes({});
  }

  @Mutation setPagination(pagination: TODO): void {
    this.pagination = pagination;
  }
  @Mutation setLoading(loading: boolean): void {
    this.loading = loading;
  }
  @Mutation setd_Loading(download_loading: boolean): void {
    this.download_loading = download_loading;
  }

  @Mutation setPatients(patients: Patient[]): void {
    this.patients = lodash.cloneDeep(patients);
  }
  @Mutation setTotalPatients(totalPatients: number): void {
    this.totalPatients = totalPatients;
  }

  @Mutation setTotalPages(totalPages: number): void {
    this.totalPages = totalPages;
  }
  @Mutation setCurrentPage(page: number): void {
    this.currentPage = page;
  }
  @Mutation setItems(items: PatientInfo[]): void {
    this.items = lodash.cloneDeep(items);
  }
  @Mutation setDownloaduuid(uuidlist): void {
    this.downloaduuid = uuidlist;
  }
  @Mutation setDownloadjson(jsonlist): void {
    this.downloadjson = jsonlist;
  }
  @Mutation setMeasurementTypes(measurementTypes) {
    this.measurementTypes = measurementTypes;
  }
}

export const patientModule = getModule(PatientModule); // patients;
